import { applyAccountFromUrl } from '#pplx/frontend/apps/ask/auth/accountSwitchHandler.js';
import { getActiveAccountId } from '#pplx/frontend/browser-storage/activeAccount.js';
import { applyAccountFromLastActive } from '#pplx/frontend/browser-storage/lastActiveAccount.js';
/**
 * Resolves this tab's active account at bootstrap and returns it (or `null`). Encapsulates the
 * precedence so callers don't depend on the ordering of the underlying steps:
 *
 *   `?pplx_account=` deep-link (switcher / notification)
 *     > existing per-tab `sessionStorage` (refresh)
 *     > last-visible cross-tab seed (new tab).
 *
 * Returns `null` when none of those applies — the caller can then fall back to primary-account
 * activation. Must run before the first authenticated request (header injection reads it).
 */
export function setAccountForTab() {
    applyAccountFromUrl();
    applyAccountFromLastActive();
    return getActiveAccountId();
}
//# sourceMappingURL=setAccountForTab.js.map